// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__2Xeyv","overflowing":"ReadFullNote_overflowing__1OvBz"};